import { Card, Col, Row } from "react-bootstrap";
import { IEdenMessageDetails } from "../../../api/IEdenMessage";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { getIconForType } from "../../../leap-components/icons/LeapIcons";

interface EdenMessageHeaderProps {
  licenceProfile: ILicenceProfile;
  edenMessage: IEdenMessageDetails;
}

const EdenMessageHeader = ({
  edenMessage,
  licenceProfile,
}: EdenMessageHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>{getIconForType("EDEN Message")}</td>
                  <td>
                    <h2>{`Message: ${edenMessage.reference}`}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={edenMessage.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={edenMessage.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={licenceProfile.version}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EdenMessageHeader;
